import React from "react";
import Button from "@material-ui/core/Button";
import { IButtonProperties } from "src/framework/components/buttons";

import "./style.css";

export interface FlatButtonProperties extends IButtonProperties {
  readonly disableElevation?: boolean;
}

const DEFAULT_PARAMENTERS: FlatButtonProperties = {
  disableElevation: true,
  onClick: () => {},
};

const FlatButton = (flatButtonProperties: FlatButtonProperties) => {
  let _parameters: any = {
    ...DEFAULT_PARAMENTERS,
    ...flatButtonProperties,
  };

  return <Button {..._parameters}>{_parameters.text}</Button>;
};

export { FlatButton };
